import { render, staticRenderFns } from "./GiftManagement.vue?vue&type=template&id=4a5f7a85&scoped=true&"
import script from "./GiftManagement.vue?vue&type=script&lang=js&"
export * from "./GiftManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f7a85",
  null
  
)

export default component.exports